// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"style_textAreaContainer__oKDqI","darkTextArea":"style_darkTextArea__ui7xV","label":"style_label__ftqFD","darkLabel":"style_darkLabel__-IezV"};